/* The next-bottle offer, rendered as a row inside the cart list.

   v3 changes two things from v2:
   1. It is now a real <tr> appended to the cart table's tbody, carrying the
      theme's own .cart-items__table-row class, so it inherits the same grid,
      dividers and spacing as a genuine line and reads as part of the list
      instead of a card bolted underneath.
   2. It ladders. One bottle offers a second; the two pack offers a third.

   The maths, derived from the cart and HK_PACK, never typed twice:

     one bottle    u                + $10 ship   = u + SHIP
     two pack      2u - SAVE2       + free       = 2u - SAVE2
     three pack    3u - SAVE3       + free       = 3u - SAVE3

     second bottle costs  (2u - SAVE2) - (u + SHIP)      = u - SAVE2 - SHIP
     third bottle costs   (3u - SAVE3) - (2u - SAVE2)    = u - SAVE3 + SAVE2

   Today: $20.01 for the second against $49.99 delivered on its own, and $25.00
   for the third against $39.99. Saving quoted on the third rung is SAVE3, the
   total against three singles, which is the number the sticky bar and the pack
   toast already use.

   Hard won constraints, all of them real bugs found on 8 Aug:

   - Horizon MORPHS the cart section on update and throws away anything injected.
     The row is re-inserted after each render, never inserted once.
   - Cart line indices are positional and baked in at render time. Adding a line
     invalidates them; that is the bug that made binning a bottle delete the free
     kit. This row carries NO data-key and NO ref, so it is never mistaken for a
     cart line, and hk-cart-lines is asked to resync after any change.
   - An empty stock map reads as "everything available". v2's first build offered
     Peppermint and Fragrance Free while both were sold out, because the cart page
     has no [data-product-url] element. Stock is read from the cart line's own
     handle and only trusted when it actually carries variants.
   - If the pack swap declines, the loose single is removed rather than left to
     cost the shopper the whole saving.

   ES5 only, single install, a throw here must never reach the cart. */
(function () {
  "use strict";
  if (window.__hkCartUpsell) return;
  window.__hkCartUpsell = true;
  window.HK_CART_UPSELL_VER = "2026-08-08x";

  if (!window.fetch || !window.Promise || !document.querySelector) return;

  /* Verified against the Domestic zone on 8 Aug 2026: $10 flat under $65, free
     at $65 and over. */
  var SHIP_CENTS = 1000;
  var FREE_SHIP_CENTS = 7000;

  var ID = "hk-cart-upsell";
  var busy = false;
  var lastSig = null;

  function money(c) { return "$" + (Math.abs(c) / 100).toFixed(2).replace(/\.00$/, ""); }
  function track(n) { try { if (window.fbq) window.fbq("trackCustom", n); } catch (e) {} }
  function shortName(n) { return String(n).split(" + ")[0]; }

  function readCart(cb) {
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (c) { if (c) cb(c); })
      .catch(function () {});
  }

  /* Which rung, if any. The free kit is $0 so it never counts as paid. */
  function offer(cart) {
    var P = window.HK_PACK;
    if (!P || !P.SINGLES) return null;
    var singles = 0, single = null, packLines = 0, packBottles = 0, pack = null, otherPaid = 0;
    var contents = P.PACK_CONTENTS || {};
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var price = it.final_line_price != null ? it.final_line_price : it.line_price;
      if (P.SINGLES[it.variant_id]) { singles += it.quantity; single = it; }
      else if (contents[it.variant_id]) {
        packLines++; pack = it;
        packBottles += contents[it.variant_id].length * it.quantity;
      } else if (price > 0 && it.handle !== "starter-pack") otherPaid += it.quantity;
    }
    if (otherPaid) return null;

    /* rung one: exactly one single bottle */
    if (singles === 1 && !packLines && single) {
      var u = single.final_price != null ? single.final_price : single.price;
      if (!u) return null;
      var two = (2 * u) - P.SAVE2_CENTS;
      var shipNow = u < FREE_SHIP_CENTS ? SHIP_CENTS : 0;
      var shipThen = two < FREE_SHIP_CENTS ? 1500 : 0;
      /* PRODUCT basis, deliberately, not delivered. The cart displays a product
         subtotal with shipping deferred to checkout, so quoting a delivered
         increment beside it did not add up on screen: $39.99 + $20.01 reads as
         $60.00 and the shopper actually lands on $70.00. On this basis
         $39.99 + $30.01 = $70.00, which is the number in front of them.
         Free shipping stays a separate line and the $19.98 saving is unchanged,
         because that comparison is against two singles bought delivered. */
      var cost = two - u;
      /* two loose singles in one order post at the same band as the pack, so the
         saving is the pack discount itself, not a postage difference */
      var kept = (2 * u + shipThen) - (two + shipThen);
      if (cost <= 0 || kept <= 0) return null;
      return {
        step: 2, cost: cost, kept: kept, alone: u + shipNow,
        freeShip: shipNow > 0 && shipThen === 0,
        image: (single.featured_image && single.featured_image.url) || single.image || null,
        handle: single.handle || null
      };
    }

    /* rung two: exactly one two pack, nothing else */
    if (!singles && packLines === 1 && packBottles === 2 && pack) {
      /* the cart total IS the two pack price, so the unit price falls out of it
         without a lookup: total = 2u - SAVE2 */
      var packPrice = pack.final_line_price != null ? pack.final_line_price : pack.line_price;
      var unit = (packPrice + P.SAVE2_CENTS) / 2;
      var three = (3 * unit) - P.SAVE3_CENTS;
      var cost3 = three - packPrice;
      if (cost3 <= 0) return null;
      return {
        step: 3, cost: cost3, kept: P.SAVE3_CENTS, alone: unit,
        /* true rather than assumed: the three pack total is checked against the
           same threshold the second rung uses */
        freeShip: three >= FREE_SHIP_CENTS,
        image: (pack.featured_image && pack.featured_image.url) || pack.image || null,
        handle: pack.handle || null
      };
    }
    return null;
  }

  /* Stock for the SINGLES, since a rung always adds a single and lets
     hk-pack-upgrade do the swap. Read from the single product, whose handle we
     may not have on rung two, so fall back to the known handle there. */
  /* The three pack's own image. On that rung the cart line is the TWO pack, so
     using its image illustrated what they already had rather than the upgrade.
     Fetched once, cached, and simply absent if the request fails. */
  var pack3Img = null, pack3Loading = false;
  function loadPack3Image(after) {
    if (pack3Img || pack3Loading) return;
    pack3Loading = true;
    fetch("/products/three-bottle-pack.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (p) {
        pack3Loading = false;
        if (p && p.featured_image) { pack3Img = p.featured_image; if (after) after(); }
      })
      .catch(function () { pack3Loading = false; });
  }

  var stock = null, stockLoading = false;
  function loadStock(handle, after) {
    if (stock) return after && after();
    if (stockLoading) return;
    if (!handle) return after && after();
    stockLoading = true;
    fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (p) {
        stockLoading = false;
        /* Only trust a map that actually carries variants. An empty object reads
           as "all available" downstream, which is how sold out scents shipped. */
        if (p && p.variants && p.variants.length) {
          stock = {};
          for (var i = 0; i < p.variants.length; i++) stock[p.variants[i].id] = !!p.variants[i].available;
        }
        if (after) after();
      })
      .catch(function () { stockLoading = false; if (after) after(); });
  }
  function scents() {
    var list = (window.HK_PACK && window.HK_PACK.SINGLE_LIST) || [];
    if (!stock) return list;          /* unknown: offering is better than an empty strip */
    var out = [];
    for (var i = 0; i < list.length; i++) if (stock[list[i].id] === true) out.push(list[i]);
    return out;
  }

  function styles() {
    if (document.getElementById(ID + "-css")) return;
    var s = document.createElement("style");
    s.id = ID + "-css";
    /* Sits on the theme's own row grid, so only the inner pieces need styling.
       Theme custom properties are used wherever they exist. */
    s.textContent =
      /* Only media and details are used. The button lives inside details rather
         than in the price column: a wide button in a column sized
         minmax(--cart-item-price-width, auto) stretched it from 96px to 136px
         and threw every column out of line with the real rows above. */
      /* It inherits the row grid so it lines up, which also made it read as
         another line item. A tint, a green edge and a badge separate it as an
         offer without breaking that alignment. */
      "tr#" + ID + "{background:rgba(79,122,82,.07);box-shadow:inset 3px 0 0 #4F7A52;" +
      /* vertical only: horizontal padding on a grid container moves every column
         and the row stops lining up with the real lines above it */
      "border-radius:10px;padding:14px 0 16px;margin-top:6px;align-items:start}" +
      "tr#" + ID + " .hk-cu-sub{display:inline;margin-left:8px;font-weight:600}" +
      "tr#" + ID + " .hk-cu-badge{display:inline-block;margin:0 0 6px;padding:3px 9px;border-radius:999px;" +
      "background:#4F7A52;color:#fff;font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase}" +
      "tr#" + ID + " .hk-cu-media{grid-area:media}" +
      "tr#" + ID + " .hk-cu-details{grid-area:details;min-width:0}" +
      "tr#" + ID + " .hk-cu-picker{grid-area:quantity;min-width:0;align-self:center}" +
      /* Right padding shifts the button left INSIDE its column. Widening the
         button instead would grow the column and drag every other one out of
         line with the rows above, which is the bug this already had once. */
      "tr#" + ID + " .hk-cu-cta{grid-column:3/-1;grid-row:2;justify-self:end;align-self:start;padding-top:10px}" +
      /* pinned to the price column width so the 12px inset comes OUT of it. Left
         to size itself the cell grew to 111px and squeezed the middle columns. */
      "" +
      /* shifted with transform, not padding: padding narrowed the button until the
         label looked clipped, transform moves it off the edge at full width and
         leaves the grid untouched */
      "" +
      "#" + ID + " .hk-cu-btn{width:auto;min-width:130px;white-space:nowrap;margin:0}" +
      /* the theme collapses to a narrower grid below 750px, where four columns
         do not fit; stack the picker and button under the details there */
      "@media(max-width:749px){tr#" + ID + " .hk-cu-scents{justify-content:flex-start}" +
      "tr#" + ID + " .hk-cu-picker,tr#" + ID + " .hk-cu-cta" +
      "{grid-area:details;justify-self:start;align-self:auto}" +
      "#" + ID + " .hk-cu-btn{width:auto;margin-top:10px}}" +
      /* was aspect-ratio + cover + radius + opacity, which made it sit oddly inside
         the media cell and read as spilling out. Match the real line items. */
      /* aspect-ratio is load bearing: the cart line image has no intrinsic
         height, so height:auto rendered it 49x0 and it read as spilling out. */
      "#" + ID + " img{display:block;width:100%;aspect-ratio:1;object-fit:cover;border-radius:6px}" +
      "#" + ID + " .hk-cu-title{font-size:calc(var(--font-size--md,16px) + 1px);line-height:1.3;margin:0 0 3px;font-weight:600}" +
      "#" + ID + " .hk-cu-sub{font-size:var(--font-size--sm,13px);line-height:1.4;margin:0 0 8px;" +
      "color:rgb(var(--color-foreground-rgb,0,0,0)/var(--opacity-70,.7))}" +
      "#" + ID + " .hk-cu-scents{display:flex;flex-wrap:wrap;gap:6px}" +
      "#" + ID + " .hk-cu-scent{font:inherit;font-size:var(--font-size--sm,13px);padding:5px 11px;cursor:pointer;" +
      "border:1px solid var(--color-border,rgba(0,0,0,.2));border-radius:999px;background:transparent;color:inherit}" +
      "#" + ID + " .hk-cu-scent[aria-pressed=true]{background:var(--color-foreground,#111);color:var(--color-background,#fff)}" +
      "#" + ID + " .hk-cu-btn{font:inherit;font-size:var(--font-size--sm,14px);padding:9px 16px;cursor:pointer;border:0;" +
      "border-radius:var(--style-border-radius-buttons,8px);background:#4F7A52;color:#fff;min-height:44px;white-space:nowrap}" +
      "#" + ID + " .hk-cu-btn[disabled]{opacity:.6;cursor:default}" +
      "#" + ID + " .hk-cu-note{font-size:var(--font-size--sm,13px);margin:8px 0 0}" +
      /* Drawer: three column grid, much narrower. Everything but the image goes
         in the details column, stacked, right aligned. Measured overlap before
         this: picker bottom 488 against button top 410. */
      /* Drawer: one details cell holds everything, so nothing is positioned on
         the grid at all and the row keeps the theme's own three columns. */
      /* span to the end: with only a media and a details cell, the third column
         sat empty at 96px and left the content 111px short of the row edge */
      "tr#" + ID + ".hk-cu-drawer .hk-cu-details{grid-column:2/-1;grid-row:1;min-width:0}" +
      /* chips and button on ONE line, in source order, so Add lands last.
         display:contents lifts the chips out of their group so all three are
         direct children of the same flex row. */
      "tr#" + ID + ".hk-cu-drawer .hk-cu-actions{display:flex;flex-wrap:wrap;align-items:center;" +
      "gap:6px;margin-top:10px}" +
      "tr#" + ID + ".hk-cu-drawer .hk-cu-scents{display:contents}" +
      /* was margin-left:auto, which shoved the button right and wrapped it onto a
         second line. Packed left with the chips it fits on one. */
      "tr#" + ID + ".hk-cu-drawer .hk-cu-btn{min-width:0;width:auto;margin-left:0;padding:8px 14px}" +
      "tr#" + ID + ".hk-cu-drawer .hk-cu-scent{padding:5px 9px}" +
      /* line the copy up with the text on the real rows above */
      "tr#" + ID + ".hk-cu-drawer .hk-cu-details{padding-inline:0}" +
      "#" + ID + " .hk-cu-btn{margin-top:10px}" +
      /* Mobile only, owner call 8 Aug: desktop reads well left aligned, but at
         phone width the same layout looks cramped against the edge. Centre the
         whole block inside its panel instead: image above, copy centred, the
         three controls centred in one row under it. Keyed on VIEWPORT width, not
         the drawer, because desktop was already right in both carts. */
      /* every width, not just phones: the owner wants the centred block on
         desktop too, so the media query is gone rather than duplicated. */
      "" +
      "tr#" + ID + "{grid-template-columns:1fr;text-align:center;padding:16px 12px}" +
      "tr#" + ID + " .hk-cu-media{grid-area:auto;grid-column:1;justify-self:center;max-width:110px;margin-bottom:10px}" +
      "tr#" + ID + " .hk-cu-details{grid-area:auto;grid-column:1;min-width:0}" +
      "tr#" + ID + " .hk-cu-actions{justify-content:center}" +
      "tr#" + ID + " .hk-cu-scents{justify-content:center}" +
      "tr#" + ID + " .hk-cu-picker,tr#" + ID + " .hk-cu-cta{grid-area:auto;grid-column:1;justify-self:center}" +
      "tr#" + ID + " .hk-cu-btn{margin-left:0}";
    document.head.appendChild(s);
  }

  /* The cart PAGE only. The drawer already has the sticky bar directly above it
     and two offers stacked reads as pestering. */
  /* The drawer is the cart most shoppers actually use on this store, so it gets
     the offer too. v3 excluded it on the theory that the sticky bar sits above
     it; that was wrong, because it meant the block only ever appeared on a page
     many shoppers never reach. Whichever cart UI is VISIBLE wins, and the drawer
     wins when both are, since it is the one on top. */
  function tbody() {
    var all = document.querySelectorAll("cart-items-component");
    var page = null;
    for (var i = 0; i < all.length; i++) {
      var tb = all[i].querySelector(".cart-items__table tbody");
      if (!tb || all[i].offsetParent === null) continue;
      /* 8 Aug: the drawer is EXCLUDED again. It rendered fine on desktop and the
         owner reported it glitchy on mobile, which is the one place it was never
         tested. Cart page only until that is understood; re-enabling is this one
         line. */
      if (all[i].closest("cart-drawer-component")) return tb;
      page = page || tb;
    }
    return page;
  }

  function remove() {
    var el = document.getElementById(ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);
    lastSig = null;
  }

  function render(cart) {
    var o = offer(cart);
    var tb = tbody();
    if (!o || !tb) return remove();
    var list = scents();
    if (!list.length) return remove();

    /* Horizon morphs this section repeatedly. Rebuilding on every morph would
       steal focus mid tap, so only rebuild when something really changed. */
    var sig = o.step + ":" + o.cost + ":" + o.kept + ":" + list.length + ":" + (o.step === 3 && pack3Img ? "p3" : "line");
    var existing = document.getElementById(ID);
    if (existing && sig === lastSig && tb.contains(existing)) return;
    lastSig = sig;
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    /* Prefer the three pack's own image on that rung; fall back to the cart line
       until it loads so the row never renders imageless. */
    var shownImage = o.image;
    if (o.step === 3) {
      if (pack3Img) shownImage = pack3Img;
      else loadPack3Image(function () { lastSig = null; refresh(); });
    }

    styles();
    var tr = document.createElement("tr");
    tr.id = ID;
    /* the theme's own row class, for the shared grid and divider. Deliberately
       no data-key and no ref: this must never be counted as a cart line. */
    /* The drawer's row grid is three columns with a different row order, so the
       page grid coordinates do not translate. Tag it and lay it out separately
       rather than trying to find numbers that suit both. */
    var inDrawer = !!tb.closest("cart-drawer-component");
    tr.className = "cart-items__table-row" + (inDrawer ? " hk-cu-drawer" : "");
    tr.setAttribute("role", "region");
    tr.setAttribute("aria-label", o.step === 3 ? "Add a third bottle" : "Add a second bottle");

    /* The badge already carries the saving. Repeating it in the headline put
       $24.97 on screen twice, which is what made the three pack rung look
       cluttered next to the second. Same shape as rung two now: badge is what
       they keep, headline is what it costs. */
    var title = o.step === 3
      ? "Add a third bottle for " + money(o.cost)
      : "Add a second bottle for " + money(o.cost);
    /* One number, one point. Both tails made the shopper compare two figures to
       find the offer: "on its own it is $49.99 delivered" on the second rung and
       "adds $25.00 instead of $39.99" on the third. The third rung says it all in
       the badge and the headline, so it needs no second line at all. */
    /* Owner call, 8 Aug: no saving sentence, just the shipping line. The badge
       and the headline already carry the number. Still derived: it only appears
       when the resulting order genuinely ships free. */
    var sub = o.freeShip ? (o.step === 3 ? "+ Free Express Post" : "+ Free post") : "";

    tr.innerHTML =
      '<td class="hk-cu-media">' + (shownImage ? '<img src="' + shownImage + '" alt="" loading="lazy">' : "") + "</td>" +
      '<td class="hk-cu-details">' +
        '<span class="hk-cu-badge">Save ' + money(o.kept) + "</span>" +
        (sub ? '<span class="hk-cu-sub">' + sub + "</span>" : "") +
        '<p class="hk-cu-title"><strong>' + title + "</strong></p>" +

        (inDrawer
          ? '<div class="hk-cu-actions">' +
              '<div class="hk-cu-scents" role="group" aria-label="Choose a scent"></div>' +
              '<button type="button" class="hk-cu-btn">' +
                (o.step === 3 ? "Add 3rd" : "Add") + "</button>" +
            "</div>"
          : "") +
        '<p class="hk-cu-note" hidden></p>' +
      "</td>" +
      (inDrawer ? "" :
        '<td class="hk-cu-picker">' +
          '<div class="hk-cu-scents" role="group" aria-label="Choose a scent"></div>' +
        "</td>" +
        '<td class="hk-cu-cta"><button type="button" class="hk-cu-btn">' +
          (o.step === 3 ? "Add third" : "Add bottle") + "</button></td>");

    var strip = tr.querySelector(".hk-cu-scents");
    var chosen = list[0].id;
    for (var i = 0; i < list.length; i++) {
      (function (item) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "hk-cu-scent";
        /* 238px of row will not hold "Lemon Myrtle" and "Mandarin Peel" and a
           button, so the drawer uses the first word only. */
        b.textContent = inDrawer ? String(item.name).split(" ")[0] : shortName(item.name);
        b.setAttribute("aria-pressed", item.id === chosen ? "true" : "false");
        b.addEventListener("click", function () {
          chosen = item.id;
          var all = strip.querySelectorAll(".hk-cu-scent");
          for (var j = 0; j < all.length; j++) all[j].setAttribute("aria-pressed", "false");
          b.setAttribute("aria-pressed", "true");
        });
        strip.appendChild(b);
      })(list[i]);
    }

    var btn = tr.querySelector(".hk-cu-btn");
    var note = tr.querySelector(".hk-cu-note");
    var label = btn.textContent;
    btn.addEventListener("click", function () { add(chosen, btn, note, label); });

    tb.appendChild(tr);
    track(o.step === 3 ? "HK_CartUpsell3Shown" : "HK_CartUpsell2Shown");
  }

  function say(note, msg) { if (note) { note.textContent = msg || ""; note.hidden = !msg; } }
  function reset(btn, label) { if (btn) { btn.disabled = false; btn.textContent = label; } }

  function add(id, btn, note, label) {
    if (busy || !id) return;
    busy = true;
    btn.disabled = true;
    btn.textContent = "Adding…";
    say(note, "");
    track("HK_CartUpsellAdd");

    fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r || !r.ok) {
        busy = false; reset(btn, label);
        say(note, "That scent just sold out. Try another.");
        return;
      }
      track("HK_CartUpsellAdded");
      if (window.HK_PACK && window.HK_PACK.evaluate) window.HK_PACK.evaluate();
      setTimeout(function () { settle(btn, note, label); }, 3200);
    }).catch(function () { busy = false; reset(btn, label); });
  }

  /* A single still sitting beside a pack means the swap declined. Leaving it
     there costs the shopper the entire saving, so put it back. */
  function settle(btn, note, label) {
    readCart(function (cart) {
      busy = false;
      var P = window.HK_PACK, single = null, packs = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (P.SINGLES[it.variant_id]) single = it;
        else if (P.PACK_CONTENTS && P.PACK_CONTENTS[it.variant_id]) packs++;
      }
      if (single && packs) {
        fetch("/cart/change.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: single.key, quantity: 0 })
        }).then(function (r) {
          if (!r || !r.ok) { try { if (window.console) console.warn("hk-cart-upsell: rollback rejected", r && r.status); } catch (e) {} }
          track("HK_CartUpsellRolledBack");
          say(note, "That pack just sold out. Nothing was added.");
          reset(btn, label);
          resync();
        }).catch(function () {});
        return;
      }
      resync();
      render(cart);
    });
  }

  /* Adding a line invalidates every rendered line index. This is the bug that
     made binning a bottle delete the free kit, so it is explicitly re-run. */
  function resync() {
    try { if (window.HK_LINES && window.HK_LINES.resync) window.HK_LINES.resync(); } catch (e) {}
  }

  function refresh() {
    if (!tbody()) return;
    readCart(function (cart) {
      var o = offer(cart);
      /* Rung two holds a pack, whose handle is not the singles product, so fall
         back to the handle the singles live under. */
      var handle = o && (o.step === 2 ? o.handle : "all-in-one-cleaner-concentrate");
      if (o && !stock && handle) loadStock(handle, function () { render(cart); });
      else render(cart);
    });
  }

  document.addEventListener("cart:update", function () { setTimeout(refresh, 90); });
  /* opening the drawer is a click, not a cart change, so nothing else would
     tell us the offer now has somewhere to render */
  document.addEventListener("click", function () { setTimeout(refresh, 200); }, true);

  function watch() {
    if (!window.MutationObserver) return;
    /* body, not one section: the drawer is mounted and unmounted outside any
       single section, so watching one would miss it opening entirely. */
    var section = document.body;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        if (!document.getElementById(ID)) refresh();
      }, 180);
    }).observe(section, { childList: true, subtree: true });
  }

  function boot() { refresh(); watch(); setTimeout(refresh, 1500); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.HK_CART_UPSELL = { refresh: refresh, offer: offer };
})();
